import i18n from '@/locales'
import enLocale from 'vant/lib/locale/lang/en-US'
import thLocale from 'vant/lib/locale/lang/th-TH'
import zhLocale from 'vant/lib/locale/lang/zh-CN'
export const languageMap = new Map([
  [
    'en',
    {
      key: 'en-US',
      value: enLocale
    }
  ],
  [
    'th',
    {
      key: 'th-TH',
      value: thLocale
    }
  ],
  [
    'zh',
    {
      key: 'zh-CN',
      value: zhLocale
    }
  ]
])

function extractValue(value, map) {
  if (value) {
    for (let i = 0; i < map.length; i++) {
      if (parseInt(map[i].value, 10) === parseInt(value, 10)) {
        return map[i]
      }
    }
    return map[value] ? map[value] : {}
  } else {
    if (parseInt(value, 10) === 0) {
      for (let i = 0; i < map.length; i++) {
        if (parseInt(map[i].value, 10) === parseInt(value, 10)) {
          return map[i]
        }
      }
    }
    return JSON.parse(JSON.stringify(map))
  }
}

export function withdrawTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('withdraw_type_1')
    },
    {
      value: 2,
      label: i18n.t('withdraw_type_2')
    }
  ]
  return extractValue(value, map)
}

export function autoWithdrawTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('auto_withdraw_type_1')
    },
    {
      value: 2,
      label: i18n.t('auto_withdraw_type_2')
    }
  ]
  return extractValue(value, map)
}

export function transactionStatusMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('transaction_status_1')
    },
    {
      value: 2,
      label: i18n.t('transaction_status_2')
    },
    {
      value: 3,
      label: i18n.t('transaction_status_3')
    },
    // 4 WAITING暂定和1 PEDNING保持一致
    {
      value: 4,
      label: i18n.t('transaction_status_1')
    },
    {
      value: 5,
      label: i18n.t('transaction_status_1')
    }
  ]
  return extractValue(value, map)
}

export function topUpMethodMap(value) {
  const map = [
    {
      value: 2,
      label: i18n.t('top_up_method_2')
    },
    {
      value: 1,
      label: i18n.t('top_up_method_1')
    }
  ]
  return extractValue(value, map)
}

export function transactionTypeMap(value) {
  const map = [
    // {
    //   label: i18n.t('transaction_type_4'),
    //   value: 0
    // },
    {
      label: i18n.t('transaction_type_1'),
      value: 1
    },
    {
      label: i18n.t('transaction_type_2'),
      value: 2
    },
    {
      label: i18n.t('transaction_type_3'),
      value: 3
    },
    {
      value: 4,
      label: i18n.t('transaction_type_4'),
      type: 'danger'
    },
    {
      value: 5,
      label: i18n.t('transaction_type_5'),
      type: 'danger'
    },
    {
      value: 6,
      label: i18n.t('transaction_type_6')
    },
    {
      value: 7,
      label: i18n.t('transaction_type_7'),
      type: 'danger'
    },
    {
      value: 8,
      label: i18n.t('transaction_type_8'),
      type: 'danger'
    },
    {
      value: 11,
      label: i18n.t('transaction_type_11')
    }
  ]
  return extractValue(value, map)
}

export function feedbackTypeMap(value) {
  const map = [
    {
      label: i18n.t('feedback_type_1'),
      value: 1
    },
    {
      label: i18n.t('feedback_type_2'),
      value: 2
    },
    {
      label: i18n.t('feedback_type_3'),
      value: 3
    },
    {
      label: i18n.t('feedback_type_10'),
      value: 10
    },
    {
      label: i18n.t('feedback_type_7'),
      value: 7
    },
    {
      label: i18n.t('feedback_type_4'),
      value: 4
    },
    {
      label: i18n.t('feedback_type_5'),
      value: 5
    },
    {
      label: i18n.t('feedback_type_6'),
      value: 6
    },
    {
      label: i18n.t('feedback_type_9'),
      value: 9
    },
    {
      label: i18n.t('feedback_type_8'),
      value: 8
    },
    {
      label: i18n.t('feedback_type_11'),
      value: 11
    },
    {
      label: i18n.t('feedback_type_12'),
      value: 12
    },
    {
      label: i18n.t('feedback_type_16'),
      value: 16
    }
  ]
  return extractValue(value, map)
}

export function identityAuditStatusMap(value) {
  const map = [
    {
      label: i18n.t('identity_audit_status_1'),
      value: 1
    },
    {
      label: i18n.t('identity_audit_status_2'),
      value: 2
    },
    {
      label: i18n.t('identity_audit_status_3'),
      value: 3
    }
  ]
  return extractValue(value, map)
}

export function getFlag(value) {
  const flag = {}
  switch (value) {
    case 1:
      flag.value = '+'
      flag.class = this.$store.getters.isBluepay ? 'symbol-add' : 'symbol-add-jt'
      break
    case 3:
      flag.value = '-'
      flag.class = 'symbol-subtract'
      break
  }
  return flag
}

export function getFullFlag(value) {
  // 防止初始化的时候value为空导拿不到值致webview关闭
  if (!value) return { value: '', class: '' }
  // const TRANSACTION_TYPE = {
  //   top_up: 1,
  //   mobile_top_up: 2,
  //   cash_out: 3,
  //   mobile_top_up_fail: 4,
  //   withdiaw_fail: 5
  // }
  const flag = {}
  switch (value) {
    case 1:
    case 4:
    case 5:
    case 6:
    case 11:
      flag.value = '+'
      flag.class = this.$store.getters.isBluepay ? 'symbol-add' : 'symbol-add-jt'
      break
    case 2:
    case 3:
    case 7:
    case 8:
      flag.value = '-'
      flag.class = this.$store.getters.isBluepay ? 'symbol-subtract' : 'symbol-subtract_jt'
      break
  }
  return flag
}

export function getStatusFlag(value) {
  const flag = {}
  switch (value) {
    case 1:
      flag.class = 'status-pending'
      break
    case 2:
      flag.class = 'status-success'
      break
    case 3:
      flag.class = 'status-fail'
      break
  }
  return flag
}

export function billsStatusMap(value) {
  const map = [
    // 1未支付PENDING，
    // 2部分支付PROCESSING，
    // 3已支付COMPLETED
    {
      label: i18n.t('bills_status_1'),
      value: 1,
      class: 'status-orange'
    },
    {
      label: i18n.t('bills_status_2'),
      value: 2,
      class: 'status-orange'
    },
    {
      label: i18n.t('bills_status_3'),
      value: 3,
      class: 'status-green'
    },
    {
      label: i18n.t('bills_status_4'),
      value: 4,
      class: 'status-tangerine'
    },
    {
      label: i18n.t('bills_status_5'),
      value: 5,
      class: 'status-cancel'
    }
  ]
  return extractValue(value, map)
}

export function clearTypeMap(value) {
  const map = [
    {
      label: i18n.t('balance'),
      value: 1
    },
    {
      label: i18n.t('balance'),
      value: 2
    },
    {
      label: 'J&T(online)',
      value: 3
    },
    {
      label: 'J&T(offline)',
      value: 4
    }
  ]
  return extractValue(value, map)
}

export function billTypeMap(value) {
  const map = [
    {
      label: i18n.t('bills_type_1'),
      value: 1
    },
    {
      label: i18n.t('bills_type_2'),
      value: 2
    }
  ]
  return extractValue(value, map)
}

export function consumptionTypeMap(value) {
  const map = [
    {
      label: i18n.t('consumption_type_1'),
      value: 1
    }
  ]
  return extractValue(value, map)
}

export function paymentMethodMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('payment_method_1')
    }
  ]
  return extractValue(value, map)
}

export function autoDebitStatus(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('auto_debit_status_1'),
      type: 'success'
    },
    {
      value: 2,
      label: i18n.t('auto_debit_status_2'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

export function notifyType(value) {
  const map = [
    {
      value: 2,
      label: i18n.t('notify_type_1'),
      type: 'success'
    },
    {
      value: 3,
      label: i18n.t('notify_type_2'),
      type: 'danger'
    },
    {
      value: 4,
      label: i18n.t('notify_type_3'),
      type: 'success'
    },
    {
      value: 1,
      label: i18n.t('notify_type_4'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}

export function kycLevel(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('unauthorized')
    },
    {
      value: 2,
      label: i18n.t('basic_account')
    },
    {
      value: 3,
      label: i18n.t('fully_verified')
    },
    {
      value: 1,
      label: i18n.t('notify_type_4'),
      type: 'danger'
    }
  ]
  return extractValue(value, map)
}
export function userGenderMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('MALE')
    },
    {
      value: 2,
      label: i18n.t('FEMALE')
    }
  ]
  return extractValue(value, map)
}
// 限额等级类型
export function limitLevelType(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('limit_level_type_1'),
      content: i18n.t('limit_level_content_1')
    },
    {
      value: 2,
      label: i18n.t('limit_level_type_2'),
      content: i18n.t('limit_level_content_2')
    },
    {
      value: 3,
      content: i18n.t('limit_level_content_3'),
      label: i18n.t('limit_level_type_3')
    },
    {
      value: 4,
      label: i18n.t('limit_level_type_4'),
      content: i18n.t('limit_level_content_4')
    },
    {
      value: 5,
      label: i18n.t('limit_level_type_5'),
      content: i18n.t('limit_level_content_5')
    },
    {
      value: 6,
      label: i18n.t('limit_level_type_6'),
      content: i18n.t('limit_level_content_6')
    },
    {
      value: 7,
      label: i18n.t('limit_level_type_7'),
      content: i18n.t('limit_level_content_7')
    },
    {
      value: 8,
      label: i18n.t('limit_level_type_8'),
      content: i18n.t('limit_level_content_8')
    },
    {
      value: 9,
      label: i18n.t('limit_level_type_9'),
      content: i18n.t('limit_level_content_9')
    }
  ]
  return extractValue(value, map)
}

export function userIncomerMap(value) {
  const map = [
    {
      value: 1,
      label: '≤ 15,000 THB'
    },
    {
      value: 2,
      label: '15,001-50,000 THB'
    },
    {
      value: 3,
      label: '50,001-200,000 THB'
    },
    {
      value: 4,
      label: '≥ 200,001THB'
    }
  ]
  return extractValue(value, map)
}

export function purposeTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('Daily_Expenses_Payments')
    },
    {
      value: 2,
      label: i18n.t('Money_Transfer')
    },
    {
      value: 3,
      label: i18n.t('Bill_payment')
    },
    {
      value: 4,
      label: i18n.t('Investment_Savings')
    },
    {
      value: 5,
      label: i18n.t('Donations_Charity')
    },
    {
      value: 6,
      label: i18n.t('Online_Shopping_E_Commerce')
    },
    {
      value: 7,
      label: i18n.t('Business_Merchant_Services')
    },
    {
      value: 8,
      label: i18n.t('other')
    }
  ]
  return extractValue(value, map)
}

export function nationalityMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('Thailand')
    },
    {
      value: 2,
      label: i18n.t('Foreigner')
    }
  ]
  return extractValue(value, map)
}

export function idTypeMap(value) {
  const map = [
    {
      value: 1,
      label: i18n.t('id_card')
    },
    {
      value: 2,
      label: i18n.t('passport')
    }
  ]
  return extractValue(value, map)
}
